export type BoxMarksCase = 'none' | 'marked' | 'box02';

// The cap a «buzón» tolerates: marks 1-5 are recoverable, and the SIXTH opens the incident and takes
// the box out of service. The banner reads the level against this.
export const MAX_MARKS = 5;

// Level -> which of the three renders. The incident is NOT a field on the wire: it is derived,
// because the mark that opens it also advances the counter past the cap. `>` and not `===`: nothing
// caps the counter, so a box sitting above the threshold must still read as the incident.
export function boxMarksCase(mark: number): BoxMarksCase {
  if (mark <= 0) return 'none';
  if (mark > MAX_MARKS) return 'box02';
  return 'marked';
}
